import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as powerbi from 'powerbi-client';
@Component({
  selector: 'app-powerbi-widget',
  templateUrl: './powerbi-widget.component.html',
  styleUrls: ['./powerbi-widget.component.scss']
})
export class PowerbiWidgetComponent implements OnInit, OnDestroy{
  @ViewChild('reportContainer', { static: true }) reportContainer!: ElementRef;
  @Input() pageName:string;
  @Input() embedToken:string;
  @Input() reportId:string;
  @Input() title?:string;
  @Input() reportHeight?:string;
  @Input() reportFilter?:{tableName?:string, columnName?:string, value?:string[]}[];
  constructor(){

  }

  ngOnInit(): void {
    this.embedReport();
  }


   embedReport() {
      const embedToken = this.embedToken; // Dynamic from backend
      const reportId = this.reportId;
      const embedUrl = `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=120f234a-0fe5-4efb-9ef7-d73332d10e55`;
      // const pageName = 'd3e4ca6d96e9d32635e3'; // Target page ID
      const pageName = this.pageName;
      
      const embedConfig: powerbi.IEmbedConfiguration = {
        type: 'report',
        id: reportId,
        embedUrl: embedUrl,
        accessToken: embedToken,
        tokenType: powerbi.models.TokenType.Embed,
        settings: {
          panes: {
            filters: { visible: false }, // Hide filters
            pageNavigation: { visible: false } // Hide page nav
          },
          navContentPaneEnabled: false,
          visualSettings: {
            visualHeaders: [
              {settings: { visible: false,  }} // Hide visual headers
            ]
          }
        }
      };
  
      const powerbiService = new powerbi.service.Service(powerbi.factories.hpmFactory, powerbi.factories.wpmpFactory, powerbi.factories.routerFactory);
  
      // Embed report
      const report = powerbiService.embed(this.reportContainer.nativeElement, embedConfig) as powerbi.Report;
      let isPageSet = false; // ✅ Prevent recursive call
  
      // When report is fully loaded
      report.on('loaded', () => {
        console.log('Report loaded');
      });
  
      // When visuals are rendered and ready
      report.on('rendered', async () => {
        console.log('Report rendered and ready');
        if (isPageSet) return; // Prevent repeated execution
        try {
          const pages = await report.getPages();
          console.log('Pages:', pages.map(p => p.name));
  
          const targetPage = pages.find(page => page.name === pageName);
          if (targetPage) {
            await targetPage.setActive();
            // console.log(Page set to ${pageName});
            isPageSet = true; // ✅ Set flag to stop re-running
          } else {
            // console.warn(Page ${pageName} not found);
          }
        } catch (error) {
          console.error('Failed to set active page:', error);
        }
      });
  
      // Handle errors
      report.on('error', (event) => {
        console.error('Power BI Embed Error:', event.detail);
      });

      if (this.reportFilter && Array.isArray(this.reportFilter)) {
        // Dynamically apply filters for each filter object in the array
        const filters:any = this.reportFilter.map(filterItem => ({
            $schema: "http://powerbi.com/product/schema#basic",
            target: {
                table: filterItem.tableName ?? '',
                column: filterItem.columnName ?? ''
            },
            operator: "In",
            values: filterItem.value??[''] // Apply the filter value
        }));
    
        console.log('Applying Filters:', filters);
    
        // Apply filters once the report is loaded
        report.on('loaded', () => {
            report.setFilters(filters).then(() => {
                console.log('Filters applied successfully');
            }).catch(err => {
                console.error('Error applying filters:', err);
            });
        });
    }
      // if(this.reportFilter?.value){
      //   // Dynamically apply filters
      //   const selectedCountry = this.reportFilter?.value??''; // e.g., 'India'
      //   const countryFilter: any = {
      //     $schema: "http://powerbi.com/product/schema#basic",
      //     target: {
      //       table: this.reportFilter?.tableName??'',
      //       column: this.reportFilter?.columnName??''
      //     },
      //     operator: "In",
      //     values: [selectedCountry] // Apply the selected country filter
      //   };
      //   console.log(countryFilter);
        
  
      //   // Apply the filter once the report is loaded
      //   report.on('loaded', () => {
      //     report.setFilters([countryFilter]).then(() => {
      //       console.log(`Filter applied: ${selectedCountry}`);
      //     }).catch((err) => {
      //       console.error('Error applying filter:', err);
      //     });
      //   });
      // }
    }

  ngOnDestroy(): void {
    
  }

}
